import { createSlice } from "@reduxjs/toolkit";
import { updateEmergencyOnlineStatus } from "../../reducer/emergencyOnline/updateEmergencyOnlineReducer";

const initialState = {
  isLoading: false,
  data: null,
  error: null,
};

const updateEmergencyOnlineSlice = createSlice({
  name: "updateEmergencyOnline",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateEmergencyOnlineStatus.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateEmergencyOnlineStatus.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload?.data || null;
      })
      .addCase(updateEmergencyOnlineStatus.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export default updateEmergencyOnlineSlice.reducer;
